/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Dialog_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new alarm." |
*
* @param {Alarms_Dialog_Add_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_dialog_add_description = /** @type {((inputs?: Alarms_Dialog_Add_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Dialog_Add_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Create a new alarm.")
	return /** @type {LocalizedString} */ ("Créer une nouvelle alarme.")
});